export default {
  id: null,
  title: '',
  slug: '',
  lead: '',
  how_to_play: '',
  pull_out_text: '',
  rewards: '',
  short_terms_and_conditions: '',
  terms_and_conditions: '',
  url: '',
  is_trending: false,
  rejected_at: null,
  rejected_reason: null,
  moderated_at: null,
  created_at: '',
  expires_at: '',
  deleted_at: null,
  redirect_url: '',
  permalink: '',
  casino: {
    images: {
      logo: {
        original: '',
        tiny: '',
        small: '',
        medium: '',
        large: ''
      },
      banner: {
        original: '',
        card: '',
        hero: '',
        hero_sm: '',
        optimized: ''
      },
      building: {
        original: '',
        full: '',
        medium: '',
        small: ''
      }
    },
  },
  images: {
    background: {
      card: '',
      card_sm: '',
      original: '',
      pod: '',
      tiny: ''
    },
    banner: {
      hero: '',
      hero_sm: '',
      origina: ''
    }
  },
  gameType: {
    data: []
  },
  stats: {
    read_by_number: 0
  },
  offerBadges: {
    data: []
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/store/models/offer.js